import * as React from 'react';
import { useState, useContext } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import styled from 'styled-components';
import { LocalContext } from 'context';
import Arrow from 'assets/svgs/down-arrow.svg';
import Answer from '../Answer/index.jsx';

const faqs = [
  {
    question: 'How do I register for Retina 2021?',
    answer:
      'Simply fill out the above registration form and you’ll receive an email from us requesting you to confirm your email address. On Friday 5 November, use your log-in details to sign into this website and access the livestream and poster gallery.'
  },
  {
    question: 'How much does it cost?',
    answer: `<p>Retina 2021 is completely free to attend. If you wish to make a donation to support the work of Fighting Blindness, you can donate online at <a target="blank" href="https://fightingblindness.ie/donate">fightingblindness.ie/donate</a></p>`
  },
  {
    question: 'Will I have access to the presentations and poster gallery after the event?',
    answer:
      'Yes, the Retina 2021 website and its content will be available after the event for registered attendees.'
  },
  // {
  //   question: 'Will I receive CPD points for attendance?',
  //   answer:
  //     'Yes! Retina 2021 is recognised for 7 external points by the Irish College of Ophthalmologists (ICO). This CPD recognition is accepted by all Irish Postgraduate Medical Training Bodies. A list of attendees on the day will be shared with the ICO and certificates will be issued by our research team during December 2020.'
  // },
  {
    question: 'I missed the deadline to submit an abstract for poster presentation. Can I still upload a poster?',
    answer:
      `The deadline for submitting an abstract to be considered and accepted for poster presentation has now passed. These have been reviewed by our Medical and Scientific Advisory Board and all delegates notified. If you are still interested and would like to talk to a member of the team, you can email <a href="mailto:research@fightingblindness.ie">research@fightingblindness.ie</a>`
  },
  {
    question: 'When is Public Engagement Day this year and how do I register?',
    answer:
      `Our Public Engagement Day will take place on Saturday 6 November via Zoom. Public Engagement Day is designed for people with visual impairments and features a mix of science, research and practical tools for living with sight loss. It is free and open to everyone to attend. Find out more on <a href="www.fightingblindness.ie" taget="_blank">www.fightingblindness.ie</a>`
  },
  {
    question: 'What is Retina Network Ireland and how can I participate?',
    answer:
      `Retina Network Ireland is anall-island network for early to mid-career researchers, clinicians and allied healthcare professionals in the area of vision and retinal disease who are based in, or affiliated with, Irish Institutions. The goal of this initiative is to promote conversational debate, to provide professional development opportunities and to encourage greater cross-functional collaboration. Please contact <a href="mailto:research@fightingblindness.ie">research@fightingblindness.ie</a> for further information.`
  }
];

const Accordion = ({ i, expanded, setExpanded, question, answer }) => {
  const isOpen = i === expanded;
  const { theme } = useContext(LocalContext);

  // By using `AnimatePresence` to mount and unmount the contents, we can animate
  // them in and out while also only rendering the contents of open accordions
  return (
    <>
      <Question
        theme={theme}
        initial={false}
        animate={{
          backgroundColor: isOpen ? theme.bg : theme.bgLight,
          color: isOpen ? theme.contrastTextColor : theme.textColor
        }}
        onClick={() => setExpanded(isOpen ? false : i)}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          {question}
          <DropdownArrow open={isOpen} />
        </div>
      </Question>
      <AnimatePresence initial={false}>
        {isOpen && (
          <AnswerText
            theme={theme}
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { opacity: 1, height: 'auto' },
              collapsed: { opacity: 0, height: 0 }
            }}
            transition={{ duration: 0.25, ease: [0.04, 0.62, 0.23, 0.98] }}>
            <Answer answer={answer} />
          </AnswerText>
        )}
      </AnimatePresence>
    </>
  );
};

const Dropdown = () => {
  // This approach is if you only want max one section open at a time. If you want multiple
  // sections to potentially be open simultaneously, they can all be given their own `useState`.
  const [expanded, setExpanded] = useState(false);

  return faqs.map((faq, i) => (
    <Accordion
      i={i}
      key={i}
      expanded={expanded}
      setExpanded={setExpanded}
      question={faq.question}
      answer={faq.answer}
    />
  ));
};

const Question = styled(motion.div)`
  grid-column: 1/7;
  padding: 1.5rem;
  background: ${({ theme }) => theme.bgLight};
  font-weight: 700;
  font-size: 1.25rem;
  line-height: 1.75rem;
  cursor: pointer;
  div {
    svg {
      min-width: 24px;
      height: 24px;
      path {
        stroke: ${({ theme }) => theme.fg};
      }
    }
  }
  @media (min-width: 1150px) {
    grid-column: 2/10;
  }
`;

const AnswerText = styled(motion.section)`
  grid-column: 1/7;
  background: ${({ theme }) => (theme.className === 'contrast' ? theme.bgLight : '#ddd')};

  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.textColor};
  @media (min-width: 1150px) {
    grid-column: 2/10;
  }
`;

const DropdownArrow = styled(Arrow)`
  transition-duration: 0.25s;
  transform: ${({ open }) => (open ? 'scale(1, -1) translateY(-10px)' : 'none')};
  path {
    stroke: ${({ open, theme }) => (open ? '#bdbdbd !important' : theme.fg)};
  }
`;

export default Dropdown;
